<script setup lang="ts">
import { bemBuilder } from "@chatfood/core-utils";
import { onMounted } from "vue";
import { useToast } from "@chatfood/design-system";
import PagesMenu from "../menu.vue";
import type { PagesMenusProps } from "./props";
import { MenuSelector } from "~/components/menu-selector";
import { useLocale } from "~/composables/use-locale";
import { useOutletStore } from "~/stores/outlet";
import { useMenusStore } from "~/stores/menus";

const css = bemBuilder("pages-menus");

const props = defineProps<PagesMenusProps>();

const outlet = useOutletStore();
const menusStore = useMenusStore();

const { t } = useLocale();
const { toastWarning } = useToast();

// Tells the customer why they are here when they were routed away from a menu
// that is not available for their selected fulfillment time.
onMounted(() => {
  if (!menusStore.hasUnavailableMenuNotice) return;

  menusStore.patch({ hasUnavailableMenuNotice: false });

  toastWarning(t("pages.menus.menu_unavailable_notice"));
});
</script>

<template>
  <div :class="css()">
    <PagesMenu
      v-if="menusStore.hasOneMenu"
      :ordering-mode="props.orderingMode"
      :outlet-slug="props.outletSlug"
      :menu-slug="menusStore.firstMenu.slug"
    />
    <MenuSelector
      v-else
      :outlet-id="outlet.id"
      :ordering-mode="props.orderingMode"
    />
  </div>
</template>

<style lang="scss" scoped>
.pages-menus {
  position: relative;
}
</style>
